import { useEffect, useState } from "react";
import { AdminMonthlyAttendanceApi, getMyAttendanceApi } from "../../app/api";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
export default function UserAttendance({ userId }) {

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const today = new Date();

  // ✅ NEW: FROM & TO month
  const [fromMonth, setFromMonth] = useState(
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`
  );

  const [toMonth, setToMonth] = useState(
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`
  );

  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ IMPORTANT: useEffect (PUT HERE)
  useEffect(() => {
    fetchSummary();
  }, [fromMonth, toMonth, userId]);

  // ✅ Get all months between range
  const getMonthRange = (start, end) => {
    const months = [];
    let current = new Date(start + "-01");
    const last = new Date(end + "-01");

    while (current <= last) {
      months.push({
        year: current.getFullYear(),
        month: String(current.getMonth() + 1).padStart(2, "0"),
      });

      current.setMonth(current.getMonth() + 1);
    }

    return months;
  };

  const fetchSummary = async () => {
    try {
      setLoading(true);

      const months = getMonthRange(fromMonth, toMonth);

      let finalData = null;

      for (let m of months) {
        const loggedUser = JSON.parse(localStorage.getItem("user"));
        const isOwnProfile = Number(loggedUser?.id) === Number(userId);

        const res = isOwnProfile
          ? await getMyAttendanceApi(m.month, m.year)
          : await AdminMonthlyAttendanceApi(m.month, m.year, userId);

        if (res?.success && res?.data?.length > 0) {
          const userData = userId
            ? res.data.find((u) => u.user_id == userId)
            : res.data[0];

          if (!userData) continue;

          // ✅ FIRST MONTH
          if (!finalData) {
            finalData = { ...userData };
          } else {
            // ✅ ADD VALUES (MERGE DATA)
            finalData.present_days += userData.present_days || 0;
            finalData.absent_days += userData.absent_days || 0;
            finalData.late_days += userData.late_days || 0;
            finalData.early_out_days += userData.early_out_days || 0;

            // ⏱️ TIME ADD FUNCTION
            const addTime = (t1, t2) => {
              const toSeconds = (t) => {
                const [h, m, s] = t.split(":").map(Number);
                return h * 3600 + m * 60 + s;
              };

              const total = toSeconds(t1) + toSeconds(t2);

              const h = Math.floor(total / 3600);
              const m = Math.floor((total % 3600) / 60);
              const s = total % 60;

              return `${String(h).padStart(2, "0")}:${String(m).padStart(
                2,
                "0"
              )}:${String(s).padStart(2, "0")}`;
            };

            finalData.total_working_hours = addTime(
              finalData.total_working_hours,
              userData.total_working_hours
            );

            finalData.extra_hours = addTime(
              finalData.extra_hours,
              userData.extra_hours
            );
          }
        }
      }

      setSummary(finalData);
    } catch (err) {
      console.error("Attendance summary error:", err);
      setSummary(null);
    } finally {
      setLoading(false);
    }
  };

  const totalWorkingDays =
    (summary?.present_days || 0) +
    (summary?.absent_days || 0);

  return (
    <div className="text-white">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row gap-2 justify-between items-center mb-6">
        <h3 className="text-xl font-semibold whitespace-nowrap">
          Monthly Attendance Summary
        </h3>

        {/* ✅ NEW RANGE INPUTS */}

<div className="flex gap-2 items-center">
  <input
    type="month"
    value={fromMonth}
    onChange={(e) => setFromMonth(e.target.value)}
    className="border px-3 py-1.5 rounded-md text-sm text-black"
  />

  <input
    type="month"
    value={toMonth}
    onChange={(e) => setToMonth(e.target.value)}
    className="border px-3 py-1.5 rounded-md text-sm text-black"
  />

  {/* 🔥 NEW BUTTON */}
  <button
    onClick={() => 
      // navigate("/attendance/monthly/user")
      navigate(`/attendance/monthly/user?user_id=${userId}`)  }
    className="
      px-4 py-1.5 text-sm rounded-md
      bg-gradient-to-r from-cyan-500 to-blue-500
      text-white shadow-md
      hover:scale-105 transition-all
      whitespace-nowrap
    "
  >
    View Full Report
  </button>
</div>



      </div>

      {/* LOADING */}
      {loading && (
        <div className="text-center py-10">
          Loading attendance summary...
        </div>
      )}

      {/* SUMMARY */}
      {!loading && summary && (
        <>
          {/* USER */}
          {/* <div className="flex items-center gap-3 mb-6">
            {summary.profile_pic ? (
              <img
                src={`https://uptask.visiontrek.io${summary.profile_pic}`}
                className="w-12 h-12 rounded-full object-cover"
              />
            ) : (
              <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center">
                {summary.name?.charAt(0)}
              </div>
            )}

            <div>
              <p className="font-semibold">{summary.name}</p>
            </div>
          </div> */}

          {/* CARDS */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
            <Card title="Total Working Days" value={totalWorkingDays} />
            <Card title="Present Days" value={summary.present_days} color="green" />
            <Card title="Absent Days" value={summary.absent_days} color="red" />
            <Card title="Late Days" value={summary.late_days} color="yellow" />
            <Card title="Early Out Days" value={summary.early_out_days} color="purple" />
            <Card title="Extra Hours" value={summary.extra_hours} color="blue" />
            <Card title="Working Hours" value={summary.total_working_hours} color="indigo" />
          </div>
        </>
      )}

      {/* NO DATA */}
      {!loading && !summary && (
        <div className="text-center py-10 text-gray-400">
          No attendance summary found.
        </div>
      )}
    </div>
  );
}

/* CARD */
function Card({ title, value, color }) {
  const colorClasses = {
    green: "bg-green-500/20 text-green-300",
    red: "bg-red-500/20 text-red-300",
    yellow: "bg-yellow-500/20 text-yellow-300",
    purple: "bg-purple-500/20 text-purple-300",
    blue: "bg-blue-500/20 text-blue-300",
    indigo: "bg-indigo-500/20 text-indigo-300",
  };

  return (
    <div className={`p-3 md:p-5 rounded-xl ${color ? colorClasses[color] : "bg-white/10 text-white"}`}>
      <p className="text-sm opacity-80">{title}</p>
      <p className="text-xl md:text-2xl font-bold mt-2">{value ?? "-"}</p>
    </div>
  );
}


